export const setDocuments = (documents) => ({
    type: 'SET_DOCUMENTLIST',
    documents
});